/*
 * 服务端请求实例
 * @Author: Li Chunqiang
 * @Date: 2020-07-18 20:04:18
 * @Last Modified by: Li Chunqiang
 * @Last Modified time: 2020-07-27 18:19:07
 */
import { AxiosInstance } from 'axios';
import createAxios from './axios';

// 服务端地址待补充
export default function createServerAxios(): AxiosInstance {
    const axiosInstance: AxiosInstance = createAxios({
        timeout: 10 * 1000,
    });
    
    axiosInstance.interceptors.response.use(response => {
        return response.data || {};
    }, error => {
        return Promise.reject(error);
    });
    return axiosInstance;
}
